import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "results"];
  static values = { url: String, logUrl: String, hint: { type: String, default: "" } };

  connect() {
    this.timeout = null;
    this.dialog = document.getElementById("search-palette-dialog");

    if (this.dialog) {
      this.dialog.addEventListener("open", () => {
        this.inputTarget.value = "";
        this.inputTarget.focus();
        this.resetResults();
      });
    }
  }

  disconnect() {
    clearTimeout(this.timeout);
  }

  close() {
    if (this.dialog) this.dialog.close();
  }

  search() {
    clearTimeout(this.timeout);
    const query = this.inputTarget.value.trim();

    this.timeout = setTimeout(() => {
      if (query.length > 0) {
        this.resultsTarget.src = `${this.urlValue}?q=${encodeURIComponent(query)}`;
      } else {
        this.resetResults();
      }
    }, 300);
  }

  submit() {
    const query = this.inputTarget.value.trim();
    if (query.length > 0) {
      this.close();
      window.Turbo.visit(`${this.urlValue}?q=${encodeURIComponent(query)}`);
    }
  }

  logResultClick(event) {
    const link = event.target.closest("a[href]");
    if (!link) return;

    const query = this.inputTarget.value.trim();
    if (query.length === 0) return;

    this.logQuery(query);
  }

  logQuery(query) {
    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    if (!token) return;

    fetch(this.logUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
      },
      body: JSON.stringify({ q: query }),
      keepalive: true,
    });
  }

  resetResults() {
    this.resultsTarget.removeAttribute("src");
    this.resultsTarget.innerHTML = `
      <div class="px-4 py-8 text-center">
        <p class="text-sm text-gray-500">${this.hintValue}</p>
      </div>
    `;
  }
}
